<template>
  <div id="auth">
    <div v-if="loading" class="text-center" style="margin-top: 10em">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <main class="d-flex w-100">
            <div class="container d-flex flex-column">
              <div class="row vh-100">
                <div class="col-sm-10 col-md-8 col-lg-6 mx-auto d-table h-100">
                  <div class="d-table-cell align-middle">
                    <div class="card">
                      <div class="card-body">
                        <div class="m-sm-4">
                          <div class="text-center">
                            <img
                              src="assets/img/logo-login.png"
                              alt="Reddy"
                              class="img-fluid"
                            />
                          </div>
                          <form v-on:submit.prevent="set_auth">
                            <div class="mb-3">
                              <label class="form-label"
                                >Correo electrónico</label
                              >
                              <input
                                v-model="email"
                                class="form-control form-control-lg"
                                type="email"
                                name="email"
                                placeholder="Digita tu correo electrónico"
                              />
                            </div>
                            <div class="mb-3">
                              <label class="form-label">Contraseña</label>

                              <div class="input-group">
                                <input
                                  type="password"
                                  id="dz-password"
                                  class="form-control form-control-lg"
                                  v-model="password"
                                  placeholder="Digita tu contraseña"
                                  style="border-right: none"
                                />
                                <button
                                  v-on:click="toggle_input_pass"
                                  class="btn btn-outline-secondary"
                                  type="button"
                                  style="
                                    border-left: none;
                                    border-color: #ced4da;
                                  "
                                >
                                  <i class="bx bxs-low-vision"></i>
                                </button>
                              </div>
                            </div>

                            <div class="text-center mt-3">
                              <button
                                type="submit"
                                class="btn btn-lg btn-reddy"
                              >
                                Iniciar
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Auth",
  metaInfo: {
    title: "Inicia sesión",
  },
  data() {
    return {
      loading: true,
      email: null,
      password: null,
    };
  },
  created: function () {
    var session = localStorage.getItem("sess_reddy_back");
    if (session != undefined) {
      this.$router.push("/");
      return false;
    }
    this.loading = false;
  },
  methods: {
    set_auth: function () {
      if (this.email == null || this.email == "") {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Error",
          text: "Digite su correo electrónico",
        });
        return false;
      }
      if (this.password == null || this.password == "") {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Error",
          text: "Digite su contraseña",
        });
        return false;
      }
      this.loading = true;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
      };
      let params = {
        email: this.email,
        password: this.password,
        ip: this.ip,
      };
      const vm = this;
      axios
        .post(this.$base_url + "auth/login_admin", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
            vm.loading = false;
            return false;
          }

          var session = {
            token: response.data.data.token,
            usuario: response.data.data.usuario,
          };
          localStorage.clear();
          localStorage.setItem("sess_reddy_back", JSON.stringify(session));
          vm.$router.push("/dashboard");
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "Important message",
            text: error,
          })
        )
        .finally();
    },
    toggle_input_pass: function () {
      if (document.getElementById("dz-password").type == "password") {
        document.getElementById("dz-password").type = "text";
      } else {
        document.getElementById("dz-password").type = "password";
      }
    },
  },
};
</script>